// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__25Q3e","colMaxWidth":"Table_colMaxWidth__3HU81"};